import styled from 'styled-components';

const StyledDivider = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin: 20px 0px;
`;

const Line = styled.span`
  width: 134px;
  height: 1px;
  background-color: #e9e9e9;
  margin: auto 0;
`;

const Txt = styled.span`
  margin: 0 20px;
  color: #333;
`;
export default StyledDivider;
export { Line, Txt };
